/*!

=========================================================
* Vue White Dashboard - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vue-white-dashboard
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/vue-white-dashboard/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from "vue";
import VueRouter from "vue-router";
import SocialSharing from "vue-social-sharing"
import VueGitHubButtons from "vue-github-buttons"
import "vue-github-buttons/dist/vue-github-buttons.css"
import App from "./App.vue";
import '@/assets/scss/white-dashboard.scss';
import '@/assets/css/nucleo-icons.css';
import "@/assets/demo/demo.css";

import GlobalComponents from "./globalComponents";
import GlobalDirectives from "./globalDirectives";
import RTLPlugin from "./RTLPlugin";
import i18n from "./i18n"
import SideBar from "@/components/SidebarPlugin";

import routes from "./router";
import {Axios, Repo} from "@/services/repositories";

Vue.config.productionTip = false;

// router setup

// configure router
export const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: 'nav-item active',
  scrollBehavior: (to) => {
    if (to.hash) {
      return {selector: to.hash}
    } else {
      return { x: 0, y: 0 }
    }
  }
});

export default router

router.beforeEach((to, from, next) => {
  let jwt = localStorage.getItem('jwt');
  if (jwt === null && to.path !== "/login") {
    return next('/login')
  }
  next();
  /* }else {
    let user = JSON.parse(localStorage.getItem('user'))
    if (to.matched.some(record => record.meta.is_admin)) {
      if (user.is_admin == 1) {
        next()
      } else {
        next({ name: 'userboard' })
      }
    } else {
      next()
    }
  }*/
})

Vue.prototype.$repo = Repo;

Vue.use(VueRouter);
Vue.use(VueGitHubButtons, { useCache: true });
Vue.use(GlobalComponents);
Vue.use(GlobalDirectives);
Vue.use(RTLPlugin);
Vue.use(SideBar);

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount("#app");

//security routing
